import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { useAuthStore } from '../../../application/store/AuthStore';

export const useCompany = (page?: number, itemsPerPage?: number, search?: string, subscriptionStatuses?: string[]) => {
    const {
        data: companies,
        isLoading: isLoadingCompanies
    } = useQuery({
        queryKey: ['companies', page, itemsPerPage, search, subscriptionStatuses],
        queryFn: async () => {
            const result = await container.companyRepository.getCompanies(page, itemsPerPage, search, subscriptionStatuses);
            if (result.status === 'error') throw new Error(result.error.message);
            return result;
        }
    });

    const companyIds = companies?.status === 'success' ? companies.data.map(c => c.id) : [];

    const {
        data: companySubscriptionStatuses,
        isLoading: isLoadingStatuses
    } = useQuery({
        queryKey: ['company-subscription-statuses', companyIds],
        queryFn: async () => {
            if (companyIds.length === 0) return [];
            const result = await container.subscriptionRepository.getSubscriptionStatuses(companyIds);
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data;
        },
        enabled: companyIds.length > 0
    });

    const {
        data: currentCompany,
        isLoading: isLoadingCurrent
    } = useQuery({
        queryKey: ['current-company'],
        queryFn: async () => {

            const companyId = useAuthStore.getState().companyId;
            if (!companyId) throw new Error('Company ID is not set');

            const result = await container.companyRepository.getCompany(companyId);
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data;
        }
    });

    const {
        data: userMemberships,
        isLoading: isLoadingUserMemberships
    } = useQuery({
        queryKey: ['user-memberships'],
        queryFn: async () => {
            const result = await container.companyRepository.getUserMemberships();
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data;
        }
    });

    return {
        companies: companies?.data,
        subscriptionStatuses: companySubscriptionStatuses ?? [],
        currentCompany,
        userMemberships,
        isLoading: isLoadingCompanies || isLoadingCurrent || isLoadingUserMemberships || isLoadingStatuses
    };
};
